export enum ManifestSource {
  MANUAL = 'MANUAL',
  SCHEDULED = 'SCHEDULED',
}
